import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const PaymentSuccessDescriptionItemsBlock = () => {
  const infoItems: PaymentSuccessDescriptionItemProps[] = [
    {
      icon: 'people-add',
      title: i18n.t('pricing_plans.success.description.items.add_everyone.title'),
      description: i18n.t('pricing_plans.success.description.items.add_everyone.description'),
    },
    {
      icon: 'multiple-buildings',
      title: i18n.t('pricing_plans.success.description.items.gain_time.title'),
      description: i18n.t('pricing_plans.success.description.items.gain_time.description'),
    },
    {
      icon: 'add-block',
      title: i18n.t('pricing_plans.success.description.items.set_budgets.title'),
      description: i18n.t('pricing_plans.success.description.items.set_budgets.description'),
    },
    {
      icon: 'holidays-event-go',
      title: i18n.t('pricing_plans.success.description.items.add_workplaces.title'),
      description: i18n.t('pricing_plans.success.description.items.add_workplaces.description'),
    },
    {
      icon: 'user-calendar',
      title: i18n.t('pricing_plans.success.description.items.finish_configuration.title'),
      description: i18n.t(
        'pricing_plans.success.description.items.finish_configuration.description'
      ),
    },
    {
      icon: 'send-email-envelope',
      title: i18n.t('pricing_plans.success.description.items.invite_employees.title'),
      description: i18n.t('pricing_plans.success.description.items.invite_employees.description'),
    },
  ]

  return (
    <Box
      flexDirection="row"
      justifyContent="center"
      gap="s32"
      maxWidth="narrowPage"
      flexWrap="wrap"
    >
      {infoItems.map((item) => {
        return <PaymentSuccessDescriptionItem key={item.title} {...item} />
      })}
    </Box>
  )
}

interface PaymentSuccessDescriptionItemProps {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string | JSX.Element
}

const PaymentSuccessDescriptionItem = ({
  icon,
  title,
  description,
}: PaymentSuccessDescriptionItemProps) => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      gap="s16"
      style={{
        maxWidth: '274px',
      }}
    >
      <Box
        padding="s16"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'radicalRed200',
          },
        }}
        borderRadius={{
          all: 'rel500',
        }}
      >
        <Icon.Large icon={icon} color="radicalRed1000" />
      </Box>
      <Box flexDirection="column" gap="s12" alignItems="center">
        <Box flexDirection="column" gap="s4">
          <Text color="grey1000" weight="semibold" size="300">
            {title}
          </Text>
          <Text color="grey1000" weight="normal" size="200">
            {description}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentSuccessDescriptionItemsBlock
